import { z } from 'zod'
import type { CallAiInput, UpdateContactInput } from 'app/generated/gql/graphql'
import type { CallJson } from 'app/types/entities'

const contactFormInput = z.object({
  channel: z.string().optional(),
  leadStatus: z.string().optional(),
  tags: z.array(z.string()).optional(),
  isQualified: z.boolean().optional(),
  closedLostReason: z.string().optional(),
  utmCampaign: z.string().optional(),
  utmSource: z.string().optional(),
  utmMedium: z.string().optional(),
  reportedAttribution: z.string().optional(),
  leadOwner: z
    .object({
      id: z.string({ error: 'Lead owner ID is required' }).min(1, 'Lead owner ID is required'),
      name: z.string(),
    })
    .optional(),
})

export function toContactFormInput(values: unknown): UpdateContactInput {
  return contactFormInput.parse(values)
}

export function toCallAiInput(ai: NonNullable<CallJson['ai']>): CallAiInput {
  return {
    actionItems: ai.actionItems,
    answerer: ai.answerer,
    channel: ai.channel,
    extractionDate: ai.extractionDate,
    model: ai.model,
    summary: ai.summary,
    tokenUsage: ai.tokenUsage
      ? {
          inputTokens: ai.tokenUsage.inputTokens,
          outputTokens: ai.tokenUsage.outputTokens,
          totalTokens: ai.tokenUsage.totalTokens,
        }
      : undefined,
    people: ai.people?.map((person) => ({
      appointmentDate: person.appointmentDate,
      appointmentRequested: person.appointmentRequested,
      appointmentScheduled: person.appointmentScheduled,
      appointmentTime: person.appointmentTime,
      birthDate: person.birthDate,
      email: person.email,
      index: person.index,
      insuranceProvider: person.insuranceProvider,
      isCaller: person.isCaller,
      name: person.name,
      outcomes: person.outcomes,
      patientType: person.patientType,
      phone: person.phone,
      reasonForNotScheduling: person.reasonForNotScheduling,
      referral: person.referral,
      relationship: person.relationship,
      serviceRequested: person.serviceRequested,
      treatment: person.treatment,
    })),
  }
}
